import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BtnCellRendererSignup } from 'src/app/core/grid/btn-cell-render-signup';
import { BtnCellRendererSummary } from 'src/app/core/grid/btn-cell-render-summary.component';
import { BtnCellRendererUnAssign } from 'src/app/core/grid/btn-cell-render-unassign.component';
import { ExcelService } from 'src/app/service/excel.service';

import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { GroupiTierService } from 'src/app/service/group-i/tier-level';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { GroupIHomeService } from 'src/app/service/groupi-home.service';

@Component({
  selector: 'app-groupitier',
  templateUrl: './groupitier.component.html',
  styleUrls: ['./groupitier.component.scss'],
  standalone: false,
})
export class GroupitierComponent implements OnInit {
  gridApi: any;
  selected_position_id;
  selected_round_id;
  tierItems = [];
  roundItems = [];
  icons;
  rowData = [];
  userID: string;
  selected_period_id;
  rowCount;
  isCompleted;
  isVerified;
  isRoutes;
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  defaultColDef;
  columnDefs;
  successMessage
  errorMessage
  isAccessible = false;
  GroupI_WidgetsData = {
    id_TierPosition: null,
    id_Round: null,
    id_KPI: null,
    id_Alarm: null,
    alarm_type_id: null,
    title_Tier: null,
    title_Route: null,
    isCompleted: 0,
    isVerified: 0,
    isRoutes: 0,
    isAssigned: 0,
    assigneeId: null
  }
  PeriodLabel: string
  isStatus: any;
  shouldHide: boolean = true;

  LLTValueFormatter(params) {
    let displayValue;

    if (params.data.llt == 1) { // NOSONAR
      displayValue = 'Y';
    }
    else if (params.data.llt == 0) { // NOSONAR
      displayValue = '';
    }

    return displayValue;
  }

  ContValueFormatter(params) {
    let displayValue;

    if (params.data.contingency == 1) { // NOSONAR
      displayValue = 'Y';
    }
    else if (params.data.contingency == 0) {  // NOSONAR
      displayValue = '';  
    }


    return displayValue;
  }

  gridOptions

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, public groupiService: GroupIHomeService, public groupitierService: GroupiTierService, public dialog: MatDialog,
    private readonly excelService: ExcelService, private readonly router: Router, private readonly constants: Constants, private readonly groupIStateService: GroupIStateService) {
    this.context = {
      componentParent: this
    };

    this.gridOptions = {
      theme: 'legacy'
    }

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true, suppressCellSelection: true
    }
    const tempGroupI_WidgetsData = localStorage.getItem('GroupI_WidgetsData');
    if (tempGroupI_WidgetsData) {
      this.GroupI_WidgetsData = JSON.parse(tempGroupI_WidgetsData);
    }
  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer)
    this.selected_period_id = localStorage.getItem("selectedPeriodId");
    this.groupiService.getHomeTiersData(this.selected_period_id).subscribe(data => {
      const transferBody = [];
      data.forEach(element => {

        const obj = { "tierPosition": element.tierPosition, "RoundStatus": element.roundStatus };
        transferBody.push(obj);
      });

      localStorage.setItem('gird', JSON.stringify(transferBody));
    })

    this.PeriodLabel = localStorage.getItem('selectedPeriodValue');
    this.isCompleted = this.GroupI_WidgetsData.isCompleted ? true : false;
    this.isVerified = this.GroupI_WidgetsData.isVerified ? true : false;
    this.isRoutes = this.GroupI_WidgetsData.isRoutes ? true : false;
    this.getColDef();
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">'
    };


    if (this.selected_period_id) {
      this.groupitierService.getTiersByPeriodId(this.selected_period_id).subscribe(result => {
        this.tierItems = result
        this.selected_position_id = null;
        if (result.length > 0) {
          this.selected_position_id = this.tierItems[0].tierPosition
          this.selected_position_id = Number(this.GroupI_WidgetsData.id_TierPosition) > 0 ? Number(this.GroupI_WidgetsData.id_TierPosition) : 1
          this.onTierChange();
        } else {
          this.defaultRowData();
        }

      });
    }
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
    //     this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }
  getColDef() {
    this.columnDefs = [
      {
        headerName: "Signup", field: "signup", minWidth: 60,
        cellRendererParams: { keyParam: this.shouldHide },
        cellRenderer: BtnCellRendererSignup
      },
      {
        headerName: "Domicile", field: "domicile", sortable: true, unSortIcon: true, autoHeight: true,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true, minWidth: 80,
      },
      {
        headerName: "LLT", field: "llt", autoHeight: true, sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true//, valueFormatter: this.LLTValueFormatter, minWidth: 60,
      },
      {
        headerName: "Contingency", field: "contingency", autoHeight: true, sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true//, valueFormatter: this.ContValueFormatter, minWidth: 103,
      },
      {
        headerName: "Route", field: "route", autoHeight: true, sortable: true, unSortIcon: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true, minWidth: 80,
      },
      {
        headerName: "#Issues", field: "issueTotal", autoHeight: true, sortable: true, unSortIcon: true, minWidth: 80,
      },
      {
        headerName: "#Complete", field: "issueCompleted", autoHeight: true, sortable: true, unSortIcon: true, minWidth: 99,
      },
      {
        headerName: "#Ignored", field: "issueIgnored", autoHeight: true, sortable: true, unSortIcon: true, minWidth: 80,
      },
      {
        headerName: "Status", field: "status", autoHeight: true, sortable: true, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true, minWidth: 114,
      },
      {
        headerName: "Prev. Team Member", field: "prevusername", autoHeight: true, cellClass: "left_align", minWidth: 200,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true
      },
      {
        headerName: "Team Member", field: "name", autoHeight: true, cellClass: "left_align", minWidth: 200,
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: "agTextColumnFilter", floatingFilter: true
      },
      {
        headerName: "Unassign", field: "status", cellRenderer: BtnCellRendererUnAssign, minWidth: 60,
      },
      {
        headerName: "Summary", field: "kpiId", cellRenderer: BtnCellRendererSummary, minWidth: 60,
      }];
  }


  Signup(kpiID: any, userID: any, routeName) {

    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      userID = JSON.parse(userData)?.user?.userPrincipalName;
      this.groupitierService.signUp(kpiID, userID).subscribe(
        _response => {
          this.successMessage = `YOU SUCCESSFULLY SIGNED UP FOR ${routeName}`;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, 8000);
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.refresh();
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        });
    } else {
      this.errorMessage = "User ID Error";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }

  usAssign(kpiID, userId, routeName) {
    this.groupitierService.usAssign(kpiID, userId).subscribe(
      _response => {
        this.successMessage = `${routeName} IS NOW AVAILABLE FOR SIGNUP!`;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, 8000);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.refresh();
      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      });



  }

  refresh() {
    this.loadData();
  }

  onBtExport() {
    if (this.rowData) {
      if (this.rowData.length > 0) {
        const exportData = [];
        this.rowData.forEach(e => {
          const obj = {
            kpi_ID: e.kpiId,
            ROUTE_ID: e.routeId,
            domicile: e.domicile,
            llt: e.llt,
            contingency: e.contingency,
            route: e.route,
            status_ID: e.statusId,
            status: e.status,
            network_id: e.networkId,
            user_name: e.name,
            signup: e.signup,
            completed: e.completed,
            round_complete: e.roundComplete,
            issues_total: e.issueTotal,
            issues_completed: e.issueCompleted,
            issues_ignored: e.issueIgnored
          };
          exportData.push(obj);
        });

        const headers = ['KPI_ID', 'ROUTE_ID', 'DOMICILE', 'LLT', 'CONTINGENCY', 'ROUTE', 'STATUS_ID', 'STATUS', 'NETWORK_ID', 'USER_NAME',
          'SIGNUP', 'COMPLETED', 'ROUND_COMPLETE', 'ISSUES_TOTAL', 'ISSUES_COMPLETED', 'ISSUES_IGNORED'];
        
        this.excelService.exportAsExcelFile(exportData, 'TIER-LEVEL - ' + localStorage.getItem("selectedPeriodValue"), headers);
      }
    }
  }

  onTierChange() {

    if (this.selected_position_id > 0) {
      this.GroupI_WidgetsData.id_TierPosition = Number(this.selected_position_id)
      localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
      this.groupitierService.onTierChangeGetRounds(this.selected_period_id, Number(this.selected_position_id)).subscribe(result => {
        this.roundItems = result;
        this.selected_round_id = null;
        if (result.length > 0) {
          this.selected_round_id = this.roundItems[0]
          this.selected_round_id = Number(this.GroupI_WidgetsData.id_Round) > 0 ? Number(this.GroupI_WidgetsData.id_Round) : 1
          this.onRoundChange();
        } else {
          this.defaultRowData();
        }

      });
      this.getColDef();
    }
  }

  onRoundChange() {

    const data = JSON.parse(localStorage.getItem('gird'));
    if (this.selected_round_id) {
      this.GroupI_WidgetsData.id_Round = Number(this.selected_round_id)
      localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    }

    this.isStatus = data?.find(x => x.tierPosition == this.selected_position_id)?.RoundStatus // NOSONAR
    if ( this.isStatus == 'CLOSED' || this.roundItems[this.roundItems?.length - 1] != this.GroupI_WidgetsData.id_Round ) {  // NOSONAR
      this.shouldHide = false;
    } else {
      this.shouldHide = true;
    }

    this.getColDef();
    this.loadData();
  }



  onCompleteChange() {
    this.GroupI_WidgetsData.isCompleted = this.isCompleted
    localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    this.loadData();
  }

  onVerificationChange() {
    this.GroupI_WidgetsData.isVerified = this.isVerified
    localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    this.loadData();
  }

  onRoutesChange() {
    this.GroupI_WidgetsData.isRoutes = this.isRoutes
    localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    this.loadData();
  }

  defaultRowData() {
    this.rowData = [];
    this.rowCount = this.rowData.length;
    this.gridApi?.setGridOption('rowData', this.rowData);
  }

  loadData() {

    this.defaultRowData();
    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;

      const paramsArr = {
        userId: this.userID,
        periodId: Number(this.selected_period_id),
        tierPosition: Number(this.selected_position_id),
        round: Number(this.selected_round_id),
        showVerified: Number(this.isVerified ? 1 : 0),
        showCompleted: Number(this.isCompleted ? 1 : 0),
        showMyRoutes: Number(this.isRoutes ? 1 : 0)
      };

      if (this.selected_position_id) {
        this.ngxUiLoaderService.start(this.constants.LoaderComponent);
        this.groupitierService.getTierData(paramsArr).subscribe(
          result => {
            const model = this.gridApi?.getFilterModel();
            this.rowData = JSON.parse(result);
            this.rowData.forEach(element => {
              if (element.contingency == "1") { element.contingency = 'Y' }  // NOSONAR
              else { element.contingency = null }
              if (element.llt == "1") { element.llt = 'Y' }  // NOSONAR
              else { element.llt = null }
            });
            this.gridApi?.setGridOption('rowData', this.rowData);
            this.rowCount = this.rowData.length;
            this.gridApi?.setFilterModel(model);
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          }, _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);

          });
      }
    } else {
      this.errorMessage = "User ID Error";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage() }

  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.gridApi?.setGridOption('paginationPageSize', Number(this.rowData.length))
    }
    else {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value))
    }
  }
  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }

  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  summaryTemplateRow(kpiid, tierTitle, userID) {
    this.GroupI_WidgetsData.id_KPI = Number(kpiid)
    this.GroupI_WidgetsData.title_Tier = tierTitle
    this.GroupI_WidgetsData.isAssigned = (userID == null) ? 0 : 1  // NOSONAR
    this.GroupI_WidgetsData.assigneeId = userID ? userID : null
    localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    this.openRouteLevel('route-level')
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Add To Queue',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
  openRouteLevel(route) {
    this.router.navigate([route]);
  }

}
